// extracted by mini-css-extract-plugin
export default {"root":"ProgressBar_root__enD2G","bar":"ProgressBar_bar__RSUfm","placeHolderShimmer":"ProgressBar_placeHolderShimmer__Gjz4P"};